<template>
  <v-container class="pa-4 pa-sm-8" fluid>
    <v-data-table :mobile-breakpoint="0" :headers="headers" :items="payments" class="elevation-1 mt-10" :loading="loading">
      <template #item.createdAt="{ item }">{{ new Date(parseInt(item.createdAt)) | moment("MMM DD YYYY") }} </template>
      <template #item.price="{ item }">{{ numberWithCommas(item.price) }} </template>
      <template #item.additionalMeals="{ item }">
        <AdditionalMeals :additionalMeals="item.additionalMeals" />
      </template>
      <template #item.discount="{ item }">{{ numberWithCommas(item.discount) }} </template>
      <template #item.netPrice="{ item }">{{ numberWithCommas(item.netPrice) }} </template>
    </v-data-table>
  </v-container>
</template>

<script>
import AdditionalMeals from "../../../reports/components/AdditionalMeals.vue";
export default {
  components: { AdditionalMeals },

  props: {
    history: {
      require: true,
    },
  },
  created() {
    this.listAdditionalPayments();
  },
  methods: {
    listAdditionalPayments() {
      this.loading = true;
      this.$apollo
        .watchQuery({
          query: require("../../components/salesOrder/api/listAdditionalPayments.graphql"),
          variables: {
            subscription: this.$route.query.packageId,
          },
        })
        .refetch({
          variables: {
            subscription: this.$route.query.packageId,
          },
        })
        .then(data => {
          this.loading = false;

          if (data.data.listAdditionalPayments) {
            this.payments = data.data.listAdditionalPayments;
          }
        })
        .catch(error => {
          this.loading = false;
          console.log(error);
        });
    },
  },

  data: () => ({
    loading: true,
    show_dialog_box: false,
    payments: [],
    headers: [
      {
        text: "Date",
        value: "createdAt",
        sortable: false,
      },
      { text: "Additional Meals", value: "additionalMeals", sortable: false },
      { text: "Additional Payment", value: "price", sortable: false },
      { text: "Discount", value: "discount", sortable: false },
      { text: "Net Price", value: "netPrice", sortable: false },
      { text: "Payment Method", value: "paymentMethod", sortable: false },
    ],
  }),
};
</script>
